module.exports = __webpack_public_path__ + "static/images/batched.3r1BczE.svg";